export enum FeatureName {
  HIDE_DEVCOM_PARTIAL_SALE = 'HOS-6501',
  IS_SELL_WITHOUT_REALTOR = 'HOS-6509',
  EXTENDED_BUYER_LEADS_OVERVIEW = 'HOS-6613',
  MOOVIN_INTEGRATION = 'HOS-6642',
  REMOVE_CONTACT_SCREEN = 'HOS-6824',
}

export const DEFAULT_FEATURE_SETTINGS: Record<FeatureName, boolean> = {
  [FeatureName.HIDE_DEVCOM_PARTIAL_SALE]: true,
  [FeatureName.IS_SELL_WITHOUT_REALTOR]: true,
  [FeatureName.EXTENDED_BUYER_LEADS_OVERVIEW]: true,
  [FeatureName.MOOVIN_INTEGRATION]: true,
  [FeatureName.REMOVE_CONTACT_SCREEN]: true,
}

export const getFeatureToggleValue = (
  featureName: FeatureName,
  defaultFeatureSettings = DEFAULT_FEATURE_SETTINGS
): boolean => {
  const paramValue = new URLSearchParams(location.search?.substr(1)).get(featureName)

  switch (paramValue) {
    case 'true':
      return true
    case 'false':
      return false
    default:
      return defaultFeatureSettings[featureName]
  }
}
